import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IExplicitFolderPermissionsDto } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class ExplicitFolderPermissionsService {
  private getBaseRoute(instanceId: string, connectionId: string | number): string {
    return `/api/configurations/${instanceId}/sharepoint/${connectionId}/explicit-folder-permissions`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string, connectionId: string | number): Observable<IExplicitFolderPermissionsDto> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    return this.http.get<IExplicitFolderPermissionsDto>(baseRoute);
  }
}
